import { ClassProvider, InjectionToken } from '@angular/core';
import { LogLevel } from 'app/core/logging/constants/log-level.constant';

export interface LoggingServiceInterface {
  log(level: LogLevel, message: string): void;
}

export const LOGGING_SERVICE: InjectionToken<LoggingServiceInterface> = new InjectionToken<LoggingServiceInterface>('cz-logging-service');

export function loggingServiceProvider(loggingService: new (...args: any[]) => LoggingServiceInterface): ClassProvider {
  return { provide: LOGGING_SERVICE, useClass: loggingService };
}
